const envType = process.env.VUE_APP_TITLE
import { getCookie } from "utils/core/kernel";
let baseURL = {}
if (envType === 'develop' || envType === 'test') {
  baseURL.apiURL = 'https://test-biz.prosepetal.top'
  baseURL.searchApi = 'http://test-search.blackrockread.com'
} else if (envType === 'prod') {
  var headers = getCookie('headers')?JSON.parse(getCookie('headers')):{appName:'adoread'}
  if (headers.appName == 'adoread') {
    baseURL.apiURL = 'https://client.adoread.com'
  } else if (headers.appName == 'gemnovel') {
    baseURL.apiURL = 'https://client.inktale.net'
  } else if (headers.appName == 'prosepetal') {
    baseURL.apiURL = 'https://biz.prosepetal.top'
  }
  baseURL.searchApi = 'https://search.blackrockread.com'
} else {
  baseURL.apiURL = ''
}

export default baseURL
